<template>
  <div>{{ displayNumber }} </div>
</template>

<script>
  export default {
    props:{
        number:
          { type: Number,
            default:0
          }},
    data(){
      return {
        displayNumber:0,
        interval:false
      }
    },
    watch:{
      number: function (val, oldVal) {
        clearInterval(this.interval);

        if(oldVal == val){
          return;
        }
        this.interval = window.setInterval(function(){
          if(this.displayNumber !== val){
            var change = (val - this.displayNumber) / 10;
            change = change >= 0 ? Math.ceil(change) : Math.floor(change);
            this.displayNumber = this.displayNumber + change;
          }

        }.bind(this), 50);

      }
    },
    mounted () {

      this.displayNumber = this.number ? this.number : 0;

    }
  }
</script>
